import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=e51a98c0&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e51a98c0')) {
      api.createRecord('e51a98c0', component.options)
    } else {
      api.reload('e51a98c0', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=e51a98c0&", function () {
      api.rerender('e51a98c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4u3g1VRDfEo11/JS/videoIframe.vue"
export default component.exports